import { API_HOST } from '../config';
import moment from 'moment';
import history from '../history';
import { getContentThemesFixture } from '../components/CompetitorReportDashboard/data/contentThemesFixtures';
let download = require('downloadjs');

const getHeaders = () => {
  return new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('access')}`,
  });
};

const formatResponse = (response) => {
  // An expired session used to fall through here as `undefined`: no error,
  // no redirect, the page just rendered nothing. Every competitor page is
  // behind PrivateRoute, so a 401/403 means the token is gone or stale —
  // do what the axios instances do on token_not_valid and bounce to login.
  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem('access');
    history.push('/login');
    return undefined;
  }
  // 400 is kept: these endpoints return a readable `message` with it.
  if ([200, 201, 400].includes(response.status)) return response.json();
  return undefined;
};

export function getListCompetitorBrands(brand) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/fetched-competitors?brand=${brand}`;

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function saveBrandRequestToDB(payload) {
  console.log(' == =  saveBrandRequestToDB', saveBrandRequestToDB);
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/fetched-competitors`;

  return fetch(baseURL, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: getHeaders(),
  }).then(formatResponse);
}

export function topCreatorFetch(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandName}/top-tagged-posts?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function campaignTypesFetch(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandName}/aggregated-by-type?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function creatorTypesFetch(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandName}/aggregated-by-creator-type?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function ytTopCreatorFetch(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/top-tagged-posts?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function ytCampaignTypesFetch(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/aggregated-by-type?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function campaignTypesYoutubeFetch(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/aggregated-by-type?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function creatorTypesYoutubeFetch(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/aggregated-by-creator-type?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function getHandlerData(keyword, creatorType, pageNum, searchKeyword, paidPost, sort_by_views, startDate = null, endDate = null, excluded_handles = null) {
  const apiPath = `${API_HOST}/api/v1/competitor-analysis/${keyword}/tagged-posts`;
  const params = new URLSearchParams({
    ...(creatorType !== null && { creator_type: creatorType }),
    ...(startDate !== null && { start_date: startDate }),
    ...(endDate !== null && { end_date: endDate }),
    page: pageNum,
    keyword: searchKeyword,
    paid_post: paidPost,
    sort_by_views: sort_by_views,
    ...(excluded_handles && { excluded_handles: excluded_handles })
  });
  return fetch(`${apiPath}?${params.toString()}`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access')}`,
    }),
  }).then((response) => {
    if ([200, 201, 400].includes(response.status)) return response.json();
  });
}

export function getYtHandlerData(keyword, creatorType, pageNum, startDate, endDate, searchKeyword, paidPost, sort_by_views) {
  const apiPath = `${API_HOST}/api/v1/competitor-analysis/youtube/${keyword}/tagged-posts`;
  const params = new URLSearchParams({
    ...(creatorType !== null && { creator_type: creatorType }),
    ...(startDate !== null && { start_date: startDate }),
    ...(endDate !== null && { end_date: endDate }),
    page: pageNum,
    keyword: searchKeyword ,
    paid_post: paidPost,
    sort_by_views: sort_by_views
  });
  return fetch(`${apiPath}?${params.toString()}`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access')}`,
    }),
  }).then((response) => {
    if ([200, 201, 400].includes(response.status)) return response.json();
  });
}
export function downloadInstagramData(brandName, startDate, endDate, searchKeyword, paidPost) {
  let apiPath = `${API_HOST}/api/v1/competitor-analysis/${brandName}/download?start_date=${moment(
    startDate,
  ).format('YYYY-MM-DD')}&end_date=${moment(endDate).format('YYYY-MM-DD')}&keyword=${searchKeyword}&paid_post=${paidPost}`;

  return fetch(apiPath, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access')}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      return response.blob();
    })
    .then(function (blob) {
      download(blob, 'download.csv', 'application/csv');
    });
}

export function downloadYtData(brandName, startDate, endDate, searchKeyword, paidPost) {
  let apiPath = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/download?start_date=${moment(
    startDate,
  ).format('YYYY-MM-DD')}&end_date=${moment(endDate).format('YYYY-MM-DD')}&keyword=${searchKeyword}&paid_post=${paidPost}`;
  return fetch(apiPath, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access')}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {

      return response.blob();
    })
    .then(function (blob) {
      download(blob, 'download.csv', 'application/csv');
    });
}

export function fetchCreatorTypeCategory(brandName, startDate, endDate, metric, searchKeyword, paidPost){
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandName}/category-by-type?sort_by=${metric}&keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function fetchYtCreatorTypeCategory(brandName, startDate, endDate, metric, searchKeyword, paidPost){
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/category-by-type?sort_by=${metric}&keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}


export function fetchYTPostsOverTime(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/chart-post-count?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}


export function fetchInstaPostsOverTime(brandName, startDate, endDate, searchKeyword, paidPost) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandName}/chart-post-count?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function creatorsFetch(brandName, startDate, endDate, searchKeyword, paidPost, comp_handle, excluded_handles, page = 1, other_brands = null) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandName}/creators?keyword=${searchKeyword}&page=${page}`;
  if (paidPost) {
    baseURL += `&paid_post=true`;
  }
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  if (comp_handle) {
    baseURL += `&brand_handle_comp=${comp_handle}`;
  }
  if (excluded_handles) {
    baseURL += `&excluded_handles=${excluded_handles}`;
  }
  if (other_brands) {
    baseURL += `&other_brands=${other_brands}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function ytCreatorsFetch(brandName, startDate, endDate, searchKeyword, paidPost, comp_handle, excluded_channel_ids, page = 1, other_brands = null) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/creators?keyword=${searchKeyword}&page=${page}`;
  if (paidPost) {
    baseURL += `&paid_post=true`;
  }
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  if (comp_handle) {
    baseURL += `&brand_handle_comp=${comp_handle}`;
  }
  if (excluded_channel_ids) {
    baseURL += `&excluded_channel_ids=${excluded_channel_ids}`;
  }
  if (other_brands) {
    baseURL += `&other_brands=${other_brands}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function getBase64HandlerData(keyword, creatorType, pageNum, searchKeyword, paidPost, sort_by_views, startDate, endDate, excluded_handles, included_insta_shortcodes) {
  const apiPath = `${API_HOST}/api/v1/competitor-analysis/${keyword}/tagged-posts-base64`;
  const params = new URLSearchParams({
    ...(creatorType !== null && { creator_type: creatorType }),
    ...(startDate !== null && { start_date: startDate }),
    ...(endDate !== null && { end_date: endDate }),
    page: pageNum,
    keyword: searchKeyword,
    paid_post: paidPost,
    sort_by_views: sort_by_views,
    excluded_handles: excluded_handles || "",
    included_insta_shortcodes: included_insta_shortcodes || ""
  });
  return fetch(`${apiPath}?${params.toString()}`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access')}`,
    }),
  }).then((response) => {
    if ([200, 201, 400].includes(response.status)) return response.json();
  });
}
export function getBase64YtHandlerData(keyword, creatorType, pageNum, startDate, endDate, searchKeyword, paidPost, sort_by_views, excluded_channel_ids) {
  const apiPath = `${API_HOST}/api/v1/competitor-analysis/youtube/${keyword}/tagged-posts-base64`;
  const params = new URLSearchParams({
    ...(creatorType !== null && { creator_type: creatorType }),
    ...(startDate !== null && { start_date: startDate }),
    ...(endDate !== null && { end_date: endDate }),
    page: pageNum,
    keyword: searchKeyword ,
    paid_post: paidPost,
    sort_by_views: sort_by_views,
    excluded_channel_ids: excluded_channel_ids || ""
  });
  return fetch(`${apiPath}?${params.toString()}`, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access')}`,
    }),
  }).then((response) => {
    if ([200, 201, 400].includes(response.status)) return response.json();
  });
}

export function getCombinedBrandListCompetitor(brand, report_title=null, ids=null, group_id=null) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/combined_brand_list`;

  if (ids && Array.isArray(ids)) {
    ids = ids.join(',')
  }

  return fetch(baseURL, {
    method: 'POST',
    body: JSON.stringify({ brand, report_title, ids, group_id }),
    headers: getHeaders(),
  }).then(formatResponse);
}

export function creatorTypesWithNormalTypeFetch(brandName, startDate, endDate, searchKeyword, paidPost, excluded_handles) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandName}/aggregated-by-creator-type-wth-normal-type?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  if (excluded_handles && excluded_handles.length > 0) {
    baseURL += `&excluded_handles=${excluded_handles}`
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function creatorTypesYoutubeWithNormalTypeFetch(brandName, startDate, endDate, searchKeyword, paidPost, excluded_channel_ids) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandName}/aggregated-by-creator-type-wth-normal-type?keyword=${searchKeyword}`;
  if (paidPost) {
    baseURL += `&paid_post=true`;
  }
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  if (excluded_channel_ids) {
    baseURL += `&excluded_channel_ids=${excluded_channel_ids}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

// Instagram Creators Analytics Endpoint
export function creatorsAnalyticsInstagramFetch(
  brandHandle,
  startDate = null,
  endDate = null,
  keyword = '',
  paidPost = false,
  brandHandleComp = null,
  excludedHandles = null
) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandHandle}/creators-analytics`;
  const params = new URLSearchParams();
  
  if (startDate && endDate) {
    params.append('start_date', moment(startDate).format('YYYY-MM-DD'));
    params.append('end_date', moment(endDate).format('YYYY-MM-DD'));
  }
  if (keyword) {
    params.append('keyword', keyword);
  }
  if (paidPost) {
    params.append('paid_post', 'true');
  }
  if (brandHandleComp) {
    params.append('brand_handle_comp', brandHandleComp);
  }
  if (excludedHandles) {
    params.append('excluded_handles', excludedHandles);
  }
  
  const queryString = params.toString();
  if (queryString) {
    baseURL += `?${queryString}`;
  }
  
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

// YouTube Creators Analytics Endpoint
export function creatorsAnalyticsYoutubeFetch(
  brandHandle,
  startDate = null,
  endDate = null,
  keyword = '',
  paidPost = false,
  brandHandleComp = null,
  excludedChannelIds = null
) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandHandle}/creators-analytics`;
  const params = new URLSearchParams();
  
  if (startDate && endDate) {
    params.append('start_date', moment(startDate).format('YYYY-MM-DD'));
    params.append('end_date', moment(endDate).format('YYYY-MM-DD'));
  }
  if (keyword) {
    params.append('keyword', keyword);
  }
  if (paidPost) {
    params.append('paid_post', 'true');
  }
  if (brandHandleComp) {
    params.append('brand_handle_comp', brandHandleComp);
  }
  if (excludedChannelIds) {
    params.append('excluded_channel_ids', excludedChannelIds);
  }
  
  const queryString = params.toString();
  if (queryString) {
    baseURL += `?${queryString}`;
  }
  
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function updatePostData(payload) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/update_post_data`;

  return fetch(baseURL, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: getHeaders(),
  }).then(formatResponse);
}

export function updateProfileData(payload) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/update_profile_data`;

  return fetch(baseURL, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: getHeaders(),
  }).then(formatResponse);
}

// Get all competitor reports grouped by brand
export function getCompetitorReports(brandId = null) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/combined_brand_list`;
  if (brandId) {
    baseURL += `?brand=${brandId}`;
  }

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

// Create competitor report
export function createCompetitorReport(payload) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/combined_brand_list`;

  return fetch(baseURL, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  }).then(formatResponse);
}

// Get demo reports for dashboard
export function getDemoReports(page = 1) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/demo-reports?page=${page}`;

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

// Get competitor insights for a single brand
export function getCompetitorInsights(brandId, startDate = null, endDate = null, platform = 'instagram') {
  // Use localhost:3000 for competitor-insights API, or fallback to API_HOST
  const INSIGHTS_API_HOST = process.env.REACT_APP_INSIGHTS_API_HOST || 'http://localhost:3000';
  let baseURL = `${INSIGHTS_API_HOST}/competitor-insights/${brandId}`;
  
  // Add date parameters if provided
  const params = new URLSearchParams();
  if (startDate) {
    params.append('start_date', startDate);
  }
  if (endDate) {
    params.append('end_date', endDate);
  }
  // Add platform parameter
  if (platform) {
    params.append('platform', platform === 'yt' || platform === 'youtube' ? 'youtube' : 'instagram');
  }
  
  const queryString = params.toString();
  if (queryString) {
    baseURL += `?${queryString}`;
  }

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(async (response) => {
    // Check if response is JSON before parsing
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      // Response is not JSON (likely HTML error page)
      const text = await response.text();
      throw new Error(`API returned non-JSON response. Status: ${response.status}. Response starts with: ${text.substring(0, 100)}`);
    }
    
    if ([200, 201, 400].includes(response.status)) {
      return response.json();
    }
    throw new Error(`Failed to fetch insights: ${response.status}`);
  }).catch((error) => {
    console.error('Error fetching competitor insights:', error);
    throw error;
  });
}

// Get brand overlap count
export function getBrandOverlapCount(brandHandle, startDate = null, endDate = null, keyword = '', otherBrands = '', platform = 'instagram') {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandHandle}/brand-overlap-count`;
  const params = new URLSearchParams();
  
  if (keyword) {
    params.append('keyword', keyword);
  }
  if (startDate && startDate !== '') {
    // moment can handle both Date objects and date strings
    params.append('start_date', moment(startDate).format('YYYY-MM-DD'));
  }
  if (endDate && endDate !== '') {
    // moment can handle both Date objects and date strings
    params.append('end_date', moment(endDate).format('YYYY-MM-DD'));
  }
  if (otherBrands) {
    params.append('other_brands', otherBrands);
  }
  if (platform) {
    params.append('platform', platform);
  }
  
  const queryString = params.toString();
  if (queryString) {
    baseURL += `?${queryString}`;
  }
  
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}


/**
 * Fetch which brands (from a provided list) each creator handle appears in.
 * Backend endpoint: GET /api/v1/competitor-analysis/creator-brands
 * Query params:
 *   handles        - comma-separated creator handles / channel_ids
 *   comp_brands    - comma-separated brand handles to check against
 *   start_date     - YYYY-MM-DD
 *   end_date       - YYYY-MM-DD
 *   platform       - 'instagram' | 'youtube'
 *
 * Expected response: [{ handle: 'foo', brands: ['brandA', 'brandB'] }, ...]
 */
export function getCreatorBrandsMap(handles, compBrands, startDate = null, endDate = null, platform = 'instagram') {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/creator-brands`;
  const params = new URLSearchParams();

  if (handles) params.append('handles', handles);
  if (compBrands) params.append('comp_brands', compBrands);
  if (startDate && startDate !== '') params.append('start_date', moment(startDate).format('YYYY-MM-DD'));
  if (endDate && endDate !== '') params.append('end_date', moment(endDate).format('YYYY-MM-DD'));
  if (platform) params.append('platform', platform);

  const queryString = params.toString();
  if (queryString) baseURL += `?${queryString}`;

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function createCompetitorReportDashboardReport(payload) {
  let baseURL = `${API_HOST}/api/v1/competitor-analysis/add-or-update-comp-dashboard-report`;

  return fetch(baseURL, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(payload),
  }).then(formatResponse);
}

// Auto-Track APIs
export function getAutoTrackSettings(combineId) {
  return fetch(`${API_HOST}/api/v1/competitor-analysis/auto-track/${combineId}/`, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function saveAutoTrackSettings(combineId, data) {
  return fetch(`${API_HOST}/api/v1/competitor-analysis/auto-track/${combineId}/`, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(data),
  }).then(formatResponse);
}

export function pauseAutoTrack(combineId, enabled) {
  return fetch(`${API_HOST}/api/v1/competitor-analysis/auto-track/${combineId}/pause/`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ enabled }),
  }).then(formatResponse);
}

export function runAutoTrackNow(combineId, deviceType = 'desktop') {
  return fetch(`${API_HOST}/api/v1/competitor-analysis/auto-track/${combineId}/run-now/`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ device_type: deviceType }),
  }).then(formatResponse);
}

export function generatePdf(combineId, deviceType = 'desktop') {
  return fetch(`${API_HOST}/api/v1/competitor-analysis/auto-track/${combineId}/generate-pdf/`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ device_type: deviceType }),
  }).then(formatResponse);
}

export function emailPdf(combineId, deviceType = 'desktop') {
  return fetch(`${API_HOST}/api/v1/competitor-analysis/auto-track/${combineId}/email-pdf/`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ device_type: deviceType }),
  }).then(formatResponse);
}

export function getAutoTrackHistory(combineId) {
  return fetch(`${API_HOST}/api/v1/competitor-analysis/auto-track/${combineId}/history/`, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

// Get report config by ids (for editing)
export function getCompetitorReportConfig(ids) {
  if (!ids || (Array.isArray(ids) && ids.length === 0)) {
    return Promise.resolve(null);
  }
  const idsParam = Array.isArray(ids) ? ids.join(',') : String(ids);
  const baseURL = `${API_HOST}/api/v1/competitor-analysis/comp-dashboard-report-config?ids=${encodeURIComponent(idsParam)}`;

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}


export function downloadNewInstagramData({
  brandHandles = [],   // array: ["nike", "adidas"]
  startDate,
  endDate,
  searchKeyword = "",
}) {

  const handlesParam = brandHandles.map(handle => encodeURIComponent(handle)).join(",");

  // Only format and append dates if they are valid
  const formattedStart = startDate && moment(startDate).isValid() 
    ? moment(startDate).format("YYYY-MM-DD") 
    : null;
  const formattedEnd = endDate && moment(endDate).isValid() 
    ? moment(endDate).format("YYYY-MM-DD") 
    : null;

  // console.log("Downloading instagram data for handles:", handlesParam, "from", formattedStart, "to", formattedEnd, "with keyword:", searchKeyword);

  let apiPath = `${API_HOST}/api/v1/competitor-analysis/multibrand-ig-download/?brand_handles=${handlesParam}&keyword=${searchKeyword}`;

  if (formattedStart) apiPath += `&start_date=${formattedStart}`;
  if (formattedEnd) apiPath += `&end_date=${formattedEnd}`;

  console.log("Constructed API path for instagram download:", apiPath);

  return fetch(apiPath, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Download failed");
      }
      const contentType = response.headers.get("content-type");
      return response.blob().then((blob) => ({ blob, contentType }));
    })
    .then(({ blob, contentType }) => {
      let fileName = "download";
      let mimeType = contentType;
      if (contentType.includes("spreadsheet")) {
        fileName += ".xlsx";
      } else {
        fileName += ".csv";
      }
      download(blob, fileName, mimeType);
    })
    .catch((err) => {
      console.error("Download error:", err);
    });
}

export function downloadNewYoutubeData({
  brandHandles = [],
  startDate,
  endDate,
  searchKeyword = "",
}) {
  const handlesParam = brandHandles.map(handle => encodeURIComponent(handle)).join(",");

  // Only format and append dates if they are valid
  const formattedStart = startDate && moment(startDate).isValid() 
    ? moment(startDate).format("YYYY-MM-DD") 
    : null;
  const formattedEnd = endDate && moment(endDate).isValid() 
    ? moment(endDate).format("YYYY-MM-DD") 
    : null;

  // console.log("Downloading YouTube data for handles:", handlesParam, "from", formattedStart, "to", formattedEnd, "with keyword:", searchKeyword);

  let apiPath = `${API_HOST}/api/v1/competitor-analysis/multibrand-yt-download/?brand_handles=${handlesParam}&keyword=${searchKeyword}`;

  if (formattedStart) apiPath += `&start_date=${formattedStart}`;
  if (formattedEnd) apiPath += `&end_date=${formattedEnd}`;

  console.log("Constructed API path for YouTube download:", apiPath);

  return fetch(apiPath, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access")}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Download failed");
      }
      const contentType = response.headers.get("content-type");
      return response.blob().then((blob) => ({ blob, contentType }));
    })
    .then(({ blob, contentType }) => {
      let fileName = "download";
      let mimeType = contentType;
      if (contentType.includes("spreadsheet")) {
        fileName += ".xlsx";
      } else {
        fileName += ".csv";
      }
      download(blob, fileName, mimeType);
    })
    .catch((err) => {
      console.error("Download error:", err);
    });
}

const combineIdsToQueryParam = (combineIds) =>
  Array.isArray(combineIds) ? combineIds.join(',') : String(combineIds);

/** POST /api/v1/competitor-analysis/intelligence-report/generate */
export function generateIntelligenceReport(combineIds, reportTitle, deviceType = 'desktop') {
  const baseURL = `${API_HOST}/api/v1/competitor-analysis/intelligence-report/generate`;

  return fetch(baseURL, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      combine_ids: combineIds,
      report_title: reportTitle || 'Competitor Analysis',
      device_type: deviceType,
    }),
  }).then(formatResponse);
}

/** GET /api/v1/competitor-analysis/intelligence-report/status/ */
export function getIntelligenceReportStatus(combineIds) {
  const idsParam = combineIdsToQueryParam(combineIds);
  const baseURL = `${API_HOST}/api/v1/competitor-analysis/intelligence-report/status/?combine_ids=${encodeURIComponent(
    idsParam,
  )}`;

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

/** GET /api/v1/competitor-analysis/intelligence-report/retrieve/ — HTML or JSON with html/content */
export function retrieveIntelligenceReport(combineIds) {
  const idsParam = combineIdsToQueryParam(combineIds);
  const baseURL = `${API_HOST}/api/v1/competitor-analysis/intelligence-report/retrieve/?combine_ids=${encodeURIComponent(
    idsParam,
  )}`;

  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(async (response) => {
    if (!response.ok) {
      const errText = await response.text();
      throw new Error(errText || `Failed to retrieve report (${response.status})`);
    }
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      return response.json();
    }
    return response.text();
  });
}

/** POST /api/v1/competitor-analysis/intelligence-report/send-email/ */
export function sendIntelligenceReportEmail(combineIds, recipients, deviceType = 'desktop') {
  const idsParam = combineIdsToQueryParam(combineIds);
  const baseURL = `${API_HOST}/api/v1/competitor-analysis/intelligence-report/send-email/?combine_ids=${encodeURIComponent(
    idsParam,
  )}`;

  return fetch(baseURL, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ recipients, device_type: deviceType }),
  }).then(formatResponse);
}

export function getCompetitorAudienceDemographics({ brandHandles = [], platform = 'instagram' }) {
  const handlesParam = brandHandles.map((h) => encodeURIComponent(h)).join(',');
  const url = `${API_HOST}/api/v1/competitor-analysis/multibrand-audience-demographics/?brand_handles=${handlesParam}&platform=${platform}`;
  return fetch(url, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

/**
 * Content Themes & Hooks — aggregated theme/hook usage for a brand's creators.
 *
 * GET /api/v1/competitor-analysis/{brandHandle}/content-themes
 * GET /api/v1/competitor-analysis/youtube/{brandHandle}/content-themes
 *
 * NOTE: this endpoint is not deployed yet. `formatResponse` returns undefined
 * for a 404 rather than throwing, so callers must treat a falsy resolution as
 * "not available" — see ContentThemesTab's notAvailable handling.
 *
 * REACT_APP_MOCK_CONTENT_THEMES is a local development flag only; it is never
 * set in staging or production, so fixture data cannot reach real users.
 */
const contentThemesMockEnabled = () =>
  process.env.REACT_APP_MOCK_CONTENT_THEMES === 'true';

export function getContentThemes(
  brandHandle,
  startDate,
  endDate,
  searchKeyword = '',
  paidPost = false,
  excluded_handles,
) {
  if (contentThemesMockEnabled()) {
    return Promise.resolve(getContentThemesFixture('instagram'));
  }

  let baseURL = `${API_HOST}/api/v1/competitor-analysis/${brandHandle}/content-themes?keyword=${searchKeyword}&paid_post=${paidPost}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  if (excluded_handles && excluded_handles.length > 0) {
    baseURL += `&excluded_handles=${excluded_handles}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

export function getYtContentThemes(
  brandHandle,
  startDate,
  endDate,
  searchKeyword = '',
  excluded_channel_ids,
) {
  if (contentThemesMockEnabled()) {
    return Promise.resolve(getContentThemesFixture('youtube'));
  }

  let baseURL = `${API_HOST}/api/v1/competitor-analysis/youtube/${brandHandle}/content-themes?keyword=${searchKeyword}`;
  if (startDate && endDate) {
    baseURL += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(
      endDate,
    ).format('YYYY-MM-DD')}`;
  }
  if (excluded_channel_ids) {
    baseURL += `&excluded_channel_ids=${excluded_channel_ids}`;
  }
  return fetch(baseURL, {
    method: 'GET',
    headers: getHeaders(),
  }).then(formatResponse);
}

/**
 * Content Themes & Hooks for one brand, from stored per-post classifications.
 *
 * GET /api/v1/competitor-analysis/{handle}/post-themes
 * GET /api/v1/competitor-analysis/youtube/{handle}/post-themes
 *
 * Every post carries one theme and one hook, stored server-side, so repeat
 * calls are a DB aggregation. Posts not classified yet are reported under
 * `classification.posts_pending` — poll until `classification.complete`.
 * `examples=all` returns every post behind each theme/hook for the drill-down.
 */
export function getPostThemes(
  brandHandle,
  { startDate, endDate, excludedHandles, youtube = false } = {},
) {
  const prefix = youtube ? 'youtube/' : '';
  const params = new URLSearchParams({ examples: 'all' });
  if (startDate && endDate) {
    params.set('start_date', moment(startDate).format('YYYY-MM-DD'));
    params.set('end_date', moment(endDate).format('YYYY-MM-DD'));
  }
  if (excludedHandles && excludedHandles.length > 0) {
    params.set('excluded_handles', String(excludedHandles));
  }
  const url = `${API_HOST}/api/v1/competitor-analysis/${prefix}${encodeURIComponent(
    brandHandle,
  )}/post-themes?${params.toString()}`;
  return fetch(url, { method: 'GET', headers: getHeaders() }).then(formatResponse);
}
